<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'delay.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Condition de paiement <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                     </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <div v-if="$aclInterfaceValidator('is_super_admin')">
                                  <form-toggle label="Global à tous les clients" v-model="resource.is_global"></form-toggle>
                                </div>

                                <form-text label="Référence unique" v-model="resource.slug" :required="true"></form-text>

                                <form-toggle label="Paiement cash" v-model="resource.is_cash"></form-toggle>
                                <group-line-2 v-if="!resource.is_cash">
                                  <form-text label="Délai de paiement" v-model="resource.total_days" suffix="jour(s)"></form-text>
                                  <form-text label="Délai avant rappel" v-model="resource.reminder_days" suffix="jour(s)"></form-text>
                                </group-line-2>


                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'headline'" :translations="resource.translations" :lang="client.id" label="Description courte" v-model="resource.translations[client.id].headline"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-textarea :translate-key="'description'" :translations="resource.translations" label="Description" :lang="client.id" v-model="resource.translations[client.id].description"></form-textarea>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import PaymentDeadlineService from './PaymentDeadlineService.js';
    import Edit from '../../../layouts/Edit.vue';


    export default {
        extends: Edit,
        data () {
            return {
                resource: {},
                isLoading: false,
            }
        },
        mounted: function(){
          this.option_datas = {}
          this.option_datas.payment_conditions = this.$store.getters.scope.payment_conditions;
          this.option_datas.countries = this.$store.state.countries;
        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','headline','description']);
                this.resource.is_global = this.resource.scope_id === null ? true : false;
                this.initialize()
            },
            getResource: function(){
                return PaymentDeadlineService
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/payment-condition/Edit.vue